import { store } from '@/decorators/store';
import { LateReasons } from '@/entities/LateReasons';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'LateReasons' })
export class LateReasonsStore extends AbstractEntityStore<LateReasons> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
